import I18N from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';

export const COMMON_LOCALIZED = {
  TODAY: 'Oggi' /*i18next.t('common.today')*/,
  TOMORROW: 'Domani' /*i18next.t('common.tomorrow')*/,
  ASAP: 'Il prima possibile' /*i18next.t('common.asap')*/,
  FREE_ITEM: 'Omaggio' /*i18next.t('common.free_item')*/,
  DISCOUNT: 'Sconto' /*i18next.t('common.discount')*/,
  UNHANDLED_LABELS: {
    PAY_WITH: 'Pagherò con' /*i18next.t('order.unhandled_pay_with')*/,
    PAY_EXACT_AMOUNT: 'Ho i soldi giusti' /*i18next.t('order.unhandled_exact_amount')*/,
    PAY_WITH_STAMPS: 'Pago con i buoni pasto' /*i18next.t('order.unhandled_food_stamps')*/,
  },
  // language used in selectors
  language: I18N.currentLanguage('it'),
};



// WEBPACK FOOTER //
// ./src/lib/localized.js